import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const EmbedHtml = ({ children, isBase64 = false }) => {
  const embedRef = useRef(null)

  function executeScriptTags() {
    const script = embedRef.current.querySelector('script')
    const reloadedScript = document.createElement('script')
    reloadedScript.innerHTML = script.innerHTML

    embedRef.current.appendChild(reloadedScript)
  }

  useEffect(() => {
    if (!children) {
      return
    }

    embedRef.current.innerHTML = isBase64 ? atob(children) : children
    executeScriptTags()
  }, [children, isBase64])

  return <div ref={embedRef} />
}

EmbedHtml.propTypes = {
  children: PropTypes.string,
  isBase64: PropTypes.bool,
}

export default EmbedHtml
